<div class="ev-card unselectable" id="vehicle-panel" data-testid="vehicle-panel-container" [ngClass]="{
  'hide': mobileResolution() && (mobileVisiblePanel()=='wind')}">

  <img src="assets/icons/light/ui/close.svg" class="close-icon" data-testid="vehicle-panel-close-btn" alt="close menu" (click)="onCloseClick()" />
  <app-vehicle-header [navigation]="navigation" [selectedCarNameString]="selectedCarNameString()" (click)="openCarSelectorDialog()"
    [selectedCarMultilineString]="selectedCarMultilineString()" [manageVehicles]="manageVehicles()">
  </app-vehicle-header>
  <div class="sliders-el">
    @for (prop of sliderProperties(); track prop.id) {
    @if (prop.visible) {
    <app-vehicle-property [attr.data-testid]="'vehicle-panel-property-' + prop.id" [label]="prop.label" [displayValue]="prop.displayValue" [min]="prop.min" [max]="prop.max"
      [digit]="prop.digit" [step]="prop.step" [altString]="prop.altString" [value]="prop.value" [stepButtons]="true"
      (valueDragEvent)="onSliderDrag(prop.id, $event)" (valueChangeEvent)="onSliderChange(prop.id, $event)">
    </app-vehicle-property>
    }
    }
  </div>
  <button class="ev-button primary" data-testid="vehicle-panel-options-btn" (click)="openCarSelectorDialog()">{{ languageService.languageJSON?.Global_Options }}</button>
</div>